import AppManagementStore from './appManagement';
import MoveStore from './move';
import RecoveryStore from './recovery';
import RebootStore from './reboot';
import RestartStore from './restart';
import screencapStore from './screencap';
import VasNewStore from './vasNew';
import VasIpProxyStore from './vasIpProxy';
import RepairStore from './repair';
import RenameStore from './rename';

export interface DeviceOperationTypes {
    AppManagementStore: AppManagementStore;
    MoveStore: MoveStore;
    RecoveryStore: RecoveryStore;
    RebootStore: RebootStore;
    RestartStore: RestartStore;
    screencapStore: screencapStore;
    VasNewStore: VasNewStore,
    VasIpProxyStore: VasIpProxyStore,
    RepairStore: RepairStore,
    RenameStore: RenameStore
}

const DeviceOperation = {
    AppManagementStore: new AppManagementStore(),
    MoveStore: new MoveStore(),
    RecoveryStore: new RecoveryStore(),
    RebootStore: new RebootStore(),
    RestartStore: new RestartStore(),
    screencapStore: new screencapStore(),
    VasNewStore: new VasNewStore(),
    VasIpProxyStore: new VasIpProxyStore(),
    RepairStore: new RepairStore(),
    RenameStore: new RenameStore()
}

export default DeviceOperation;
